import { Link } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@brent/core-ui/ui'
import { Button } from '@brent/core-ui/ui'

export function Dashboard() {
  const { user } = useAuth()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">Welcome back, {user?.name || user?.email}</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Suggestions</CardTitle>
            <CardDescription>View and manage piece suggestions from members</CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild>
              <Link to="/suggestions">View Suggestions</Link>
            </Button>
          </CardContent>
        </Card>

        {user?.groups.includes('administrator') && (
          <Card>
            <CardHeader>
              <CardTitle>Members</CardTitle>
              <CardDescription>Manage member accounts in the member portal</CardDescription>
            </CardHeader>
            <CardContent>
              <Button asChild>
                <Link to="/users">Manage Members</Link>
              </Button>
            </CardContent>
          </Card>
        )}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Your Access</CardTitle>
          <CardDescription>Your current roles and permissions</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div>
              <span className="font-medium">Email:</span> {user?.email}
            </div>
            <div>
              <span className="font-medium">Groups:</span>{' '}
              {user?.groups.length ? user.groups.join(', ') : 'No groups assigned'}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
